const tabContentDefaultStyle = theme => {
  const style = {
    marginTop: '16px',
    marginLeft: '8px',
    fontFamily: 'Roboto Flex',
    fontSize: '16px',
    lineHeight: '125%'
  };
  return style;
};
export default tabContentDefaultStyle;